import { useMemo } from "react";
import { useQuery } from "react-query";
import { fetcher } from "~/lib/misc";
import { useSession } from "~/state-containers/session";

export const getCurrentUser = (session) => async () => {
  if (!session) return;
  const response = await fetcher(
    process.env.NEXT_PUBLIC_API_BASE_URL + "/users/me",
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session}`,
      },
    }
  );

  return response;
};

export const useCurrentUser = (initialData) => {
  const { session } = useSession();
  const {
    data: currentUser,
    error,
    isLoading,
    refetch,
  } = useQuery("/users/me", getCurrentUser(session), {
    initialData,
  });

  const isAdmin = useMemo(() => currentUser?.role === "admin", [currentUser]);
  const isCoach = useMemo(() => currentUser?.role === "coach", [currentUser]);

  return {
    session,
    currentUser,
    isAdmin,
    isCoach,
    error,
    refetch,
    isLoading,
  };
};
